module.exports = function getResource(label, vars = []) {
    let resources = { freeShipping: 'Free Shipping' };
    return resources[label];
};
